export default __webpack_public_path__ + "static/media/pixxxx.b0239c8e.jpg";